import { render } from "./AnomaliesJustifOK.vue?vue&type=template&id=6879f357"
import script from "./AnomaliesJustifOK.vue?vue&type=script&lang=js"
export * from "./AnomaliesJustifOK.vue?vue&type=script&lang=js"

import "./AnomaliesJustifOK.vue?vue&type=style&index=0&id=6879f357&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__